import { render, staticRenderFns } from "./Ama.vue?vue&type=template&id=7b07db05"
import script from "./Ama.vue?vue&type=script&lang=js"
export * from "./Ama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports